export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10927.ce9b3be9.jpg";